import { InputAdornment, IconButton } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { softColors } from "../constants/colors";


const StyledSearchField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#ffffff",
    borderRadius: theme.spacing(2),
    border: `1px solid ${softColors.border}`,
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      borderColor: softColors.primary,
    },
    "& fieldset": {
      border: "none",
    },
    "&.Mui-focused": {
      boxShadow: `0 0 0 2px ${alpha(softColors.primary, 0.1)}`,
    },
  },
}));

const SearchBar = ({ searchTerm, setSearchTerm }) => {
  return (
    <StyledSearchField 
      label="חיפוש"
      variant="outlined"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      margin="normal"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton>
              <SearchIcon color="action" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;